import { render, staticRenderFns } from "./ListeActionsCorrectives.vue?vue&type=template&id=5dd8c8d2&scoped=true"
import script from "./ListeActionsCorrectives.vue?vue&type=script&lang=js"
export * from "./ListeActionsCorrectives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd8c8d2",
  null
  
)

export default component.exports